// `/campaigns/new` — create wizard route (US-125..US-130).

import { createRoute, useNavigate } from '@tanstack/react-router';

import { CreateWizard } from '@/features/campaigns/CreateWizard';

import { Route as CampaignsLayoutRoute } from './__layout';

export const Route = createRoute({
  getParentRoute: () => CampaignsLayoutRoute,
  path: 'new',
  component: CampaignsNew,
});

function CampaignsNew() {
  const navigate = useNavigate();
  return (
    <CreateWizard
      onCreated={(id) => {
        void navigate({ to: '/campaigns/$id', params: { id } });
      }}
    />
  );
}
